function pad(value: number): string {
  return String(value).padStart(2, "0");
}

/** Formats a local calendar day as an ISO date ("YYYY-MM-DD"), ignoring the time and time zone. */
function toIsoDate(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
}

/** Parses an ISO date ("YYYY-MM-DD") as a local calendar day at midnight. */
function parseIsoDate(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function formatIsoDate(value: string | undefined, locale?: string): string {
  if (!value) {
    return "—";
  }
  return parseIsoDate(value).toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

const isoDate = {
  toIsoDate,
  parseIsoDate,
  formatIsoDate,
};

export default isoDate;
